import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { t } = useLanguage();

  // Standard slide transition logic


  const slides = [
    {
      title: t('hero.slide1Title'),
      subtitle: t('hero.slide1Subtitle'),
      description: t('hero.slide1Desc')
    },
    {
      title: t('hero.slide2Title'),
      subtitle: t('hero.slide2Subtitle'),
      description: t('hero.slide2Desc')
    },
    {
      title: t('hero.slide3Title'),
      subtitle: t('hero.slide3Subtitle'),
      description: t('hero.slide3Desc')
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const scrollToExpertise = () => {
    const expertiseSection = document.getElementById('expertise');
    if (expertiseSection) {
      expertiseSection.scrollIntoView({ behavior: 'smooth' });
    }
  };



  return (
    <section className="relative h-[100svh] min-h-[550px] md:min-h-[650px] overflow-hidden bg-gray-900">
      {/* Hero Background Video */}
      <div className="absolute inset-0 bg-gray-900">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          poster="/news-bg.jpg"
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
          style={{ backgroundColor: '#0a1628' }}
        >
          <source src="/background.mp4" type="video/mp4" />
        </video>
        {/* Overlays for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
      </div>



      {/* Content - pushed down to account for header */}
      <div className="relative z-10 h-full flex items-center pt-[140px] md:pt-[120px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full">
          <div className="max-w-full md:max-w-3xl">
            {/* Animated slide content */}
            <div className="transition-all duration-500 ease-in-out">
              <h2 className="text-white text-base sm:text-lg md:text-xl mb-2 font-semibold" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.7)' }}>
                {slides[currentSlide].subtitle}
              </h2>
              <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold mb-3 md:mb-4 leading-tight" style={{ textShadow: '2px 2px 6px rgba(0,0,0,0.7)' }}>
                {slides[currentSlide].title}
              </h1>
              <p className="text-white text-base sm:text-lg md:text-xl mb-6 md:mb-8 max-w-xl font-medium" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.6)' }}>
                {slides[currentSlide].description}
              </p>
            </div>

            {/* Slide indicators - larger on mobile for touch */}
            <div className="flex space-x-3 sm:space-x-2 mt-6 md:mt-8">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`h-3 sm:h-3 rounded-full transition-all min-h-[44px] flex items-center ${currentSlide === index
                    ? 'bg-white w-8 sm:w-8'
                    : 'bg-white/50 hover:bg-white/70 w-3 sm:w-3'
                    }`}
                  aria-label={`Go to slide ${index + 1}`}
                >
                  <span className={`block h-3 rounded-full ${currentSlide === index ? 'bg-white w-8' : 'bg-white/50 w-3'
                    }`} />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
